import styled from 'styled-components';

export const StyledLoggedInApp = styled.div`
	display: flex;
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow: hidden;
`;
